import React from "react";
import sample from "../assets/sampleimage.png";
import Lottie from "lottie-react";
import Fa from "../assets/Fag.json";

const Fag = () => {
  return (
    <div>
      <div className="faq-banner">
        <Lottie animationData={Fa} loop className="faq-lottie" />
      </div>

      <div className="container mb-4">
        <div className="card shadow-lg border-0 p-3">
          <h3 className="mb-3 fw-bold text-center">
            Frequently Asked Questions
          </h3>

          <div className="accordion" id="faqAccordion">
           
            <div className="accordion-item">
              <h2 className="accordion-header" id="headingOne">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseOne"
                >
                  1. What is your return policy?
                </button>
              </h2>

              <div
                id="collapseOne"
                className="accordion-collapse collapse"
                data-bs-parent="#faqAccordion"
              >
                <div className="accordion-body">
                  We offer a 7-day return policy for unused items in original
                  condition.
                </div>
              </div>
            </div>

            {/* Q2 */}
            <div className="accordion-item">
              <h2 className="accordion-header" id="headingTwo">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseTwo"
                >
                  2. Do you provide free shipping?
                </button>
              </h2>

              <div
                id="collapseTwo"
                className="accordion-collapse collapse"
                data-bs-parent="#faqAccordion"
              >
                <div className="accordion-body">
                  Yes, free shipping is available for all prepaid orders above
                  ₹499.
                </div>
              </div>
            </div>

            {/* Q3 */}
            <div className="accordion-item">
              <h2 className="accordion-header" id="headingThree">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseThree"
                >
                  3. How can I track my order?
                </button>
              </h2>

              <div
                id="collapseThree"
                className="accordion-collapse collapse"
                data-bs-parent="#faqAccordion"
              >
                <div className="accordion-body">
                  You will receive a tracking link via SMS & Email once your
                  order ships.
                </div>
              </div>
            </div>

            {/* Q4 */}
            <div className="accordion-item">
              <h2 className="accordion-header" id="headingFour">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseFour"
                >
                  4. Can I modify my order after placing it?
                </button>
              </h2>

              <div
                id="collapseFour"
                className="accordion-collapse collapse"
                data-bs-parent="#faqAccordion"
              >
                <div className="accordion-body">
                  Orders can be modified within 2 hours of placing them.
                </div>
              </div>
            </div>

            {/* Q5 */}
            <div className="accordion-item">
              <h2 className="accordion-header" id="headingFive">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseFive"
                >
                  5. Do you offer cash on delivery (COD)?
                </button>
              </h2>

              <div
                id="collapseFive"
                className="accordion-collapse collapse"
                data-bs-parent="#faqAccordion"
              >
                <div className="accordion-body">
                  Yes, COD is available for selected locations.
                </div>
              </div>
            </div>

            {/* Q6 */}
            <div className="accordion-item">
              <h2 className="accordion-header" id="headingSix">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseSix"
                >
                  6. How do I contact customer support?
                </button>
              </h2>

              <div
                id="collapseSix"
                className="accordion-collapse collapse"
                data-bs-parent="#faqAccordion"
              >
                <div className="accordion-body">
                  You can reach us via email or our Contact Us page 24/7.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Fag;
